class QueryParamsModule {
  private updateUrl(params: URLSearchParams): string {
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState(null, '', newUrl);

    return window.location.href;
  }

  setParam<Key extends string = string>(key: Key, value: string): string {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);

    const newUrl = this.updateUrl(params);

    return newUrl;
  }

  setParamsList<Key extends string = string>(
    key: Key,
    values: string[],
  ): string {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);

    values.forEach((value) => {
      params.append(key, value);
    });

    const newUrl = this.updateUrl(params);

    return newUrl;
  }

  getParam<Key extends string = string, Ret extends string | null = null>(
    key: Key,
  ) {
    const params = new URLSearchParams(window.location.search);
    return params.get(key) as Ret;
  }

  getParamsList<Key extends string = string>(key: Key): string[] {
    const params = new URLSearchParams(window.location.search);
    return params.getAll(key);
  }

  removeParam<Key extends string = string>(key: Key): string {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);

    const newUrl = this.updateUrl(params);

    return newUrl;
  }
}

export const queryParamsModule = new QueryParamsModule();
